import * as React from "react";
import type { TypeChartLegendProps } from "./ChartLegendTypes";
import ChartLegendHybrid from "./ChartLegendHybrid";

const ChartLegend = (props: TypeChartLegendProps) => (
  <ChartLegendHybrid {...props} />
);

export default ChartLegend;
